'use strict';

var React = require('react');
var LinkButton = require('../elements/LinkButton.jsx');

var STYLEGUIDE_DATA = {
	colors: [
		{color: 'Röd/-2', hex: '#f5cfd4'},
		{color: 'Röd/-1', hex: '#eb9eab'},
		{color: 'Röd', hex: '#cf0f29'},
		{color: 'Röd/1', hex: '#9c0d21'},
		{color: 'Röd/2', hex: '#660814'},

		{color: 'Orange/-2', hex: '#fcded1'},
		{color: 'Orange/-1', hex: '#fabfa3'},
		{color: 'Orange', hex: '#f25e17'},
		{color: 'Orange/1', hex: '#b54712'},
		{color: 'Orange/2', hex: '#782e0d'},

		{color: 'Gul/-2', hex: '#fff2d1'},
		{color: 'Gul/-1', hex: '#ffe8a3'},
		{color: 'Gul', hex: '#ffc21c'},
		{color: 'Gul/1', hex: '#bf9114'},
		{color: 'Gul/2', hex: '#80610d'},

		{color: 'Grön/-2', hex: '#dbedd4'},
		{color: 'Grön/-1', hex: '#b8dea8'},
		{color: 'Grön', hex: '#4aab29'},
		{color: 'Grön/1', hex: '#38801f'},
		{color: 'Grön/2', hex: '#265414'},

		{color: 'Blå/-2', hex: '#cce8fa'},
		{color: 'Blå/-1', hex: '#99d1f5'},
		{color: 'Blå', hex: '#008ce5'},
		{color: 'Blå/1', hex: '#0069ab'},
		{color: 'Blå/2', hex: '#004573'},

		{color: 'Lila/-2', hex: '#e5cced'},
		{color: 'Lila/-1', hex: '#cc99db'},
		{color: 'Lila', hex: '#7d00a6'},
		{color: 'Lila/1', hex: '#5e007d'},
		{color: 'Lila/2', hex: '#400054'},

		{color: 'Rosa/-2', hex: '#fcdee3'},
		{color: 'Rosa/-1', hex: '#fabfc7'},
		{color: 'Rosa', hex: '#f25e73'},
		{color: 'Rosa/1', hex: '#b54757'},
		{color: 'Rosa/2', hex: '#7a303b'},

		{color: 'Vit', hex: '#ffffff'},
		{color: '4% svart', hex: '#f6f6f6'},
		{color: '10% svart', hex: '#e5e5e5'},
		{color: '20% svart', hex: '#cccccc'},
		{color: '30% svart', hex: '#b3b3b3'},
		{color: '40% svart', hex: '#999999'},
		{color: '50% svart', hex: '#808080'},
		{color: '60% svart', hex: '#666666'},
		{color: '70% svart', hex: '#4d4d4d'},
		{color: '80% svart', hex: '#333333'},
		{color: '90% svart', hex: '#1a1a1a'},
		{color: 'Svart', hex: '#000000'}
	]
};

var BackgroundColor = React.createClass({
	displayName: 'BackgroundColor',
	propTypes: {
		color: React.PropTypes.string
	},

	render: function () {
		var color = this.props.color;
		var divStyle = {
			backgroundColor: color
		};

		return (
			<div className="svtse_styleguide-colors__columns-circle" style={divStyle} />
		);
	}
});


module.exports = React.createClass({

	displayName: 'StyleGuidePage',

	render: function () {

		var colors = STYLEGUIDE_DATA.colors;

		return (
			<section className="svtse_section svtse_section--white">

				<div className="svtse_styleguide">

					<article className="svtse_styleguide-colors">
						<h1 className="svtse_styleguide-colors__header">Färger / Översikt</h1>
							<div className="svtse_styleguide-colors__grid">
								{colors.map(function (item, index) {
									return (
										<div className="svtse_styleguide-colors__columns">
											<BackgroundColor color={item.hex} />
											<div className="svtse_styleguide-colors__columns-text">{item.color}</div>
										</div>
									);
								})}
							</div>
					</article>

					<article className="svtse_styleguide-buttons">
						<h1 className="svtse_styleguide-buttons__header">KNAPPAR</h1>

						<h2>Default</h2>

						<LinkButton url="http://google.se">
							Default knapp
						</LinkButton>

						<LinkButton url="http://google.se" state="hover">
							Default knapp HOVER
						</LinkButton>

						<LinkButton url="http://google.se" isSelected={true}>
							Default knapp Selected
						</LinkButton>

						<LinkButton url="http://google.se" state="active">
							Default knapp active
						</LinkButton>

						<LinkButton url="http://google.se" state="focus">
							Default knapp focus
						</LinkButton>

						<LinkButton url="http://google.se" state="disabled">
							Default knapp disabled
						</LinkButton>


						<h2>Theme News</h2>

						<LinkButton url="http://google.se" theme="news">
							News theme
						</LinkButton>

						<LinkButton url="http://google.se" theme="news" isSelected={true}>
							News theme selected
						</LinkButton>

						<LinkButton url="http://google.se" state="hover" theme="news">
							News theme HOVER
						</LinkButton>

						<LinkButton url="http://google.se" theme="news" isSelected={true}>
							News theme selected
						</LinkButton>

						<LinkButton url="http://google.se" state="active" theme="news">
							News theme active
						</LinkButton>

						<LinkButton url="http://google.se" state="focus" theme="news">
							News theme focus
						</LinkButton>

						<LinkButton url="http://google.se" state="disabled" theme="news">
							News theme disabled
						</LinkButton>

						<h2>Theme Play</h2>

						<LinkButton url="http://google.se" theme="play">
							play theme
						</LinkButton>

						<LinkButton url="http://google.se" state="hover" theme="play">
							play theme HOVER
						</LinkButton>

						<LinkButton url="http://google.se" state="active" theme="play">
							play theme active
						</LinkButton>

						<LinkButton url="http://google.se" state="focus" theme="play">
							play theme focus
						</LinkButton>

						<LinkButton url="http://google.se" state="disabled" theme="play">
							play theme disabled
						</LinkButton>

						<h2>Theme Kids</h2>

						<LinkButton url="http://google.se" theme="kids">
							Kids theme
						</LinkButton>

						<LinkButton url="http://google.se" state="hover" theme="kids">
							Kids theme HOVER
						</LinkButton>

						<LinkButton url="http://google.se" state="active" theme="kids">
							Kids theme active
						</LinkButton>

						<LinkButton url="http://google.se" state="focus" theme="kids">
							Kids theme focus
						</LinkButton>

						<LinkButton url="http://google.se" state="disabled" theme="kids">
							Kids theme disabled
						</LinkButton>


						<h2>Ikoner och så</h2>

						<LinkButton url="http://google.se" icon={['arrow-right','after',true]}>
							arrow-right after animatable
						</LinkButton>

						<LinkButton url="http://google.se" icon={['arrow-right','before']}>
							arrow-right before
						</LinkButton>

						<LinkButton url="http://google.se" icon={['search','after']}>
							search after
						</LinkButton>

						<LinkButton url="http://google.se" icon={['world-ban','before',true]}>
							world-ban before animateable
						</LinkButton>


						<h2>Olika modifiers</h2>


						<LinkButton url="http://google.se" modifiers="xs">
							Extra small
						</LinkButton>
						<LinkButton url="http://google.se" modifiers="small">
							small
						</LinkButton>
						<LinkButton url="http://google.se" modifiers="medium">
							medium
						</LinkButton>
						<LinkButton url="http://google.se" modifiers="">
							Ingen modifier
						</LinkButton>
						<LinkButton url="http://google.se" modifiers="large">
							Large
						</LinkButton>

						<LinkButton url="http://google.se" modifiers="full-width">
							Full width
						</LinkButton>
						<LinkButton url="http://google.se" modifiers="full-width" icon="arrow-left">
							Full width arrow-left
						</LinkButton>
						<LinkButton url="http://google.se" modifiers={['small','full-width']} icon="arrow-left">
							full width and small arrow-left
						</LinkButton>



					</article>

				</div>
			</section>
		);
	}

});



/** WEBPACK FOOTER **
 ** ./app/components/StyleGuideHandler/StyleGuideComponent.jsx
 **/